export class APIResult<T> {
  data!: {
    items: T[];
    total: number;
  };
}

export class APICountResult {
  data!: number;
}
